module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 105
// module chunks = 1